import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getAppBaseUrl } from "../../main/utils";
import { useBrand } from "../providers/brand/brand-context";

export default function RedirectToAlohomora({
  finalizeLogout,
}: {
  finalizeLogout?: boolean;
}) {
  const location = useLocation();
  const brand = useBrand();
  const brandId = brand.getProp<string>("id");
  const alohomoraHost = brand.getProp("Alohomora.host");

  useEffect(() => {
    const returnTo = `${getAppBaseUrl()}${location.pathname}${location.search}`;

    const alohomoraUrl = new URL(
      `https://${alohomoraHost}/${finalizeLogout ? "logout" : ""}`
    );
    alohomoraUrl.searchParams.append("redirect_uri", returnTo);
    alohomoraUrl.searchParams.append("brand", brandId);
    window.location.href = alohomoraUrl.toString();
  }, [location, alohomoraHost, brandId, finalizeLogout]);

  return null;
}
